namespace TabAurous.Retail {
    export interface POSSalesReceiptDetailsForm {
        DenominationId: Serenity.IntegerEditor;
        Count: Serenity.IntegerEditor;
        Amount: Serenity.DecimalEditor;
    }

    export class POSSalesReceiptDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.POSSalesReceiptDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSSalesReceiptDetailsForm.init)  {
                POSSalesReceiptDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(POSSalesReceiptDetailsForm, [
                    'DenominationId', w0,
                    'Count', w0,
                    'Amount', w1
                ]);
            }
        }
    }
}
